import { Select } from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const AudioSettings = lib.styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .title {
    margin-top: 20px;
    font-size: 18px;
    font-weight: bold;
  }

  .subtitle {
    font-weight: 700;
    align-self: flex-start;
    margin: 10px 0 10px 20px;
  }

  .icon {
    width: 45px!important;
    height: auto!important;
    color: ${colors.white};
  }

  .mic {
    background-color: ${colors.green};
  }

  .input {
    width: 100%!important;
    margin-top: 3px;
    &:after {
      border-color: ${colors.lightBlue}!important;
    }
  }
`;

export const Icon = lib.styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  border-radius: 50px;
  background-color: ${colors.lightBlue}
`;

export const Mic = lib.styled.div`
  width: 100%;
  margin-top: 40px;
  max-width: 343px;

  span {
    font-weight: bold;
  }

  .icon-2 {
    width: 25px;
    height: auto;
  }

  .row {
    display: flex;
    flex-direction: row;
    margin-left: -3px;
  }

  .mic-analyzer {
    margin-top 7px;
  }

  .border {
    border-color: ${colors.lightBlue}!important;
  }
`;

export const SelectDevice = lib.styled(Select)`
`;

export const AudioTest = lib.styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  margin-top: 10px;


  .icon {
    display: flex;
    width: 25px!important;
    height: 25px!important;
    justify-content: center;
    align-items: center;
    background-color: ${colors.lightBlue};
    border-radius: 50px;
    margin-right: 10px;

    .MuiSvgIcon-root {
      font-size: 20px;
    }
  }

  span {
    font-size: 14px;
    font-weight: 500;
  }
`;

export const CallTest = lib.styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-top: 50px;

  .MuiSvgIcon-root {
    font-size: 20px;
    margin-right: 10px;
  }

  &:hover {
    opacity: .7;
  }
`;
